export const REMOVE_TNO = "remove_data";
export const ADD_TNO = "save_data";
export const REMOVE = "remove";
